export default __webpack_public_path__ + "static/100782-b3fe2b3e9a68f962bcccfc4853ce98a6.jpg";